// extracted by mini-css-extract-plugin
export default {"Services":"Services_Services__hU7Mo","ServicesTitle":"Services_ServicesTitle__vQtME","ServicesList":"Services_ServicesList__1AERX","ServicesLink":"Services_ServicesLink__PuZtk"};